const Decryption = {
    key: process.env.REACT_APP_DATA_OBFUSCATION_KEY,
    iv: process.env.REACT_APP_DATA_OBFUSCATION_IV,
};

export default Decryption;
